export default __webpack_public_path__ + "static/media/footer-logo.e43c76ce.png";